import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { I18nProvider } from "./i18n";
import { refreshMe } from "./lib/auth";
import { installAudioUnlock } from "./lib/sfx";
import "./styles/app.css";

installAudioUnlock();
void refreshMe();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </StrictMode>,
);
